import { css, SerializedStyles } from '@emotion/core'
import range from 'lodash.range'
import * as React from 'react'

import { breakpoints } from '../constants/breakPoints'

interface GridProps {
  id?: string
  columns?: number
  columnsTemplate?: string
  twoColumnsForTablet?: boolean
  twoColumnsForMobile?: boolean
  noBreakForTablet?: boolean
  noBreak?: boolean
  columnGap?: number
  rowGap?: number
  rowGapMobile?: number
  breakPoint?: number
  maxWidth?: string
  responsiveReversed?: boolean
  className?: string
  alignContent?: string
  cssStyles?: SerializedStyles | (boolean | SerializedStyles)[]
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  children?: React.ReactNode
}

const Grid: React.FunctionComponent<GridProps> = ({
  id,
  columns = 1,
  columnsTemplate,
  twoColumnsForTablet = false,
  twoColumnsForMobile = false,
  noBreakForTablet = false,
  noBreak = false,
  columnGap,
  rowGap,
  rowGapMobile,
  responsiveReversed = false,
  breakPoint = 768,
  maxWidth,
  className,
  alignContent = 'center',
  children,
  cssStyles,
  onClick,
}) => {
  return (
    <div
      id={id}
      className={className}
      onClick={onClick}
      css={[
        gridContainerStyle(
          columns,
          alignContent,
          columnsTemplate,
          twoColumnsForTablet,
          twoColumnsForMobile,
          breakPoint,
          noBreakForTablet,
          noBreak,
          columnGap,
          rowGap,
          rowGapMobile,
          maxWidth,
          responsiveReversed
        ),
        cssStyles,
      ]}
    >
      {children}
    </div>
  )
}

export default Grid

const gridContainerStyle = (
  columns: number,
  alignContent?: string,
  columnsTemplate?: string,
  twoColumnsForTablet?: boolean,
  twoColumnsForMobile?: boolean,
  breakPoint?: number,
  noBreakForTablet?: boolean,
  noBreak?: boolean,
  columnGap?: number,
  rowGap?: number,
  rowGapMobile?: number,
  maxWidth?: string,
  responsiveReversed?: boolean
) => css`
  display: grid;
  margin: 0 auto;
  width: 100%;
  max-width: ${maxWidth ? maxWidth : '1136px'};
  align-items: ${alignContent ? alignContent : 'center'};
  grid-template-columns: ${columnsTemplate ? columnsTemplate : `repeat(${columns},1fr)`} ${noBreak && '!important'};
  gap: ${rowGap !== undefined ? `${rowGap}rem` : '3rem'} ${columnGap !== undefined ? `${columnGap}rem` : '1rem'};

  & > img {
    width: 100%;
  }

  @media screen and (max-width: ${breakPoint || breakpoints.medium}px) {
    ${twoColumnsForTablet ? 'grid-template-columns: 1fr 1fr' : !noBreakForTablet && 'grid-template-columns: 1fr'};
    row-gap: ${rowGapMobile ? `${rowGapMobile}rem !important` : rowGap ? `${rowGap}rem` : '2.5rem'};
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    grid-template-columns: ${twoColumnsForMobile && !noBreak ? '1fr 1fr' : '1fr'};
    ${!noBreak && 'grid-gap:  1rem;'};
    & > div,
    h2,
    img {
      grid-column: initial;
    }
  }

  ${responsiveReversed &&
  `
    @media screen and (max-width: ${breakPoint}px) {
    ${range(0, columns)
      .map((i) => `& > *:nth-of-type(${i + 1}) { order: ${columns - i}; }`)
      .join('\n')}
  }
  `}
`
